import { create } from "zustand"
import { filterLabelMap, translations } from "../i18n/translations"

export const useLanguageStore = create((set, get) => ({
    defaultLanguage: "sv",
    storageKey: "languagePreference",
    language: localStorage.getItem("languagePreference") || "sv",

    setLanguage: (language) => set({ language: language }),

    getValueFromPath: (object, path) => {
        return path.split(".").reduce((acc, key) => {
            if (acc && typeof acc === "object") {
                return acc[key]
            }
            return undefined
        }, object)
    },

    formatWithParams: (value, params = {}) => {
        if (typeof value !== "string") return value
        return value.replace(/\{(\w+)}/g, (_, match) => {
            return params[match] ?? `{${match}}`
        })
    },

    translate: (key, params) => {
        const localized =
            get().getValueFromPath(translations[get().language], key) ??
            get().getValueFromPath(translations[get().defaultLanguage], key) ??
            key
        return get().formatWithParams(localized, params)
    },

    translateFilterLabel: (type, value) => {
        const entry = filterLabelMap[type]?.[value]
        if (!entry) return value
        return entry[get().language] ?? entry[get().defaultLanguage] ?? value
    },
}))
